import { useIsSaber } from '../utils/qualSistema';
import configUrlOrgao from './urls/configUrlOrgao';

export const useOrgaoRoutes = () => {
  const isSaber = useIsSaber();

  // Prefixo dinâmico dependendo do layout
  const layoutPrefix = isSaber ? '/saber' : '/site/admin';

  return {
    ORGAO_CREATE:  isSaber ? configUrlOrgao.ORGAO_CREATE_SABER : configUrlOrgao.ORGAO_CREATE_SITE,
    ORGAO_EDIT:  isSaber ? configUrlOrgao.ORGAO_EDIT_SABER : configUrlOrgao.ORGAO_EDIT_SITE,
    ORGAO_LIST:  isSaber ? configUrlOrgao.ORGAO_LIST_SABER : configUrlOrgao.ORGAO_LIST_SITE,
    ORGAO_EDIT_LK:  isSaber ? configUrlOrgao.ORGAO_EDIT_LK_SABER : configUrlOrgao.ORGAO_EDIT_LK_SITE,
    ORGAO_LOGO:  isSaber ? configUrlOrgao.ORGAO_LOGO_SABER : configUrlOrgao.ORGAO_LOGO_SITE,

    ORGAO_FILTER_BY_SEARCH_EP: configUrlOrgao.ORGAO_FILTER_BY_SEARCH_EP, // não muda com layout
    ORGAO_API_EP: configUrlOrgao.ORGAO_API_EP, // não muda com layout
    ORGAO_API_EP_AXIOS: configUrlOrgao.ORGAO_API_EP_AXIOS // não muda com layout
  };
};
